/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Logo, Page, Group, Copy, Title, BodyCopy, Link } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'pages/auth/newinvitationsent/newinvitationsent_styles';



/* ========== ~~~~~~~~~~ AUTH NEW INVITATION SENT ~~~~~~~~~~ ========== */
class NewInvitationSent extends Component{
    constructor(props){
        super(props);
        this.state = {
            linkLocked: false,
            countDown: null,
            intervalFunction: null
        }
    }
    componentDidMount(){
       if(this.props.tokenData.userUUID) this.lockLinkForXSeconds(30)
    }
    handleLinkClick = () => {
        if(this.props.tokenData.userUUID && !this.state.linkLocked){
            this.props.resendInvite(this.props.tokenData.userUUID, true);
            this.lockLinkForXSeconds(30)
        }
    };
    lockLinkForXSeconds = (seconds) => {
        this.setState({linkLocked: true, countDown: seconds, intervalFunction: setInterval(this.countDown, 1000)});
    };
    countDown = () => {
        this.state.countDown ? this.setState({countDown: this.state.countDown-1}) : this.endCountDown();
    };
    endCountDown = () => {
        clearInterval(this.state.intervalFunction);
        this.setState({linkLocked: false})
    };
    render(){
        return (
            <Page name={`newinvitationsent`} klass={this.props.classes.newinvitationsent}>
                <Group name={`main`}>
                    <Copy>
                        <Title>
                            <Logo/>
                        </Title>
                        <BodyCopy>
                            <h3>New Invitation Sent</h3>
                            <ul>
                                <li>
                                    We sent an email to the address associated to this account with a new invitation link (make sure to check the spam folder)
                                </li>
                                <li>
                                    Your new link will be valid only for 24 hours
                                </li>
                            </ul>
                            <p className={'sendagain'} >Email didn't arrive? <Link type={'action'} disabled={this.state.linkLocked} action={this.handleLinkClick} text={ this.state.linkLocked ? `Try again in ${this.state.countDown} seconds.` : 'Send again.'} /></p>
                        </BodyCopy>
                    </Copy>
                </Group>
                <p className={'contactus'} >Still having issues signing up? <Link text={'Contact Us'} underline={true} type={'external'} action={'https://www.insticator.com/contact/'} /> </p>
            </Page>)
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(NewInvitationSent);
